export const styles = {
  buttonContainer: {
    paddingTop: '32px',
    paddingLeft: '34px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  wrapper: {
    display: 'flex',
    gap: '12px',
    width: '100%',
    padding: '32px 0px 14px 32px',
    position: 'static',
  },
  replyWrapper: {
    height: 'auto',
    width: '100%',
    minHeight: '212px',
    padding: '16px',
    borderRadius: '16px',
    border: (theme) => `1px solid ${theme.palette.blues.primaryBlue100}`,
    boxShadow: (theme) => theme.customShadows.bottomShadow,

    '& .ql-insertTemplate': {
      position: 'relative',
      width: '75px!important',
      padding: '4px 6px!important',
      background: (theme) => `${theme.palette.blues.primaryBlue500}!important`,
      borderRadius: '4px',
    },

    '& .ql-insertTemplate::after': {
      content: `'Templates'`,
      position: 'absolute',
      width: '100%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#fff',
      fontSize: '11px',
      whiteSpace: 'nowrap',
    },
  },
  receiversWrapper: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    marginBottom: '12px',
  },
  receivers: {
    flex: 1,
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  cc: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
  sender: {
    fontSize: '16px',
    fontWeight: 500,
    color: (theme) => theme.palette.grays.gray500,
  },
  editorContainer: {
    padding: '14px 0px',

    '& .ql-toolbar.ql-snow': {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      padding: '12px',
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    },
    '& .ql-container.ql-snow ': {
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
      borderBottom: '0',
    },
    '& .ql-signatureAction:hover': {
      svg: {
        fill: '#06c',
      },
    },
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '14px',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  signatureWrapper: {
    borderRadius: '8px',
    border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    borderTop: 0,
    marginTop: '-20px',
    padding: '24px 15px 12px 15px',
    fontSize: '13px',
    lineHeight: 1.42,
    fontFamily: 'Helvetica, Arial, sans-serif',
    '& p': {
      margin: 0,
    },

    '& h1, & h2, & h3, & h4, & h5, & h6': {
      margin: 0,
      fontWeight: 600,
    },

    '& pre': {
      margin: 0,
      overflow: 'auto',
    },

    '& ol': {
      margin: 0,
      padding: 0,
    },
  },
};
